import { render, staticRenderFns } from "./section-title.vue?vue&type=template&id=f05efb80&scoped=true"
import script from "./section-title.vue?vue&type=script&lang=js"
export * from "./section-title.vue?vue&type=script&lang=js"
import style0 from "./section-title.vue?vue&type=style&index=0&id=f05efb80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05efb80",
  null
  
)

export default component.exports